import { handleActions, combineActions } from 'redux-actions';
import { combineReducers } from 'redux';
import * as actionTypes from './constants';

export const documents = handleActions(
  {
    [actionTypes.DOCUMENTS_REQUEST]: () => [],
    [actionTypes.DOCUMENTS_SUCCESS]: (state, { payload }) => payload,
  },
  [],
);

export const isLoading = handleActions(
  {
    [combineActions(actionTypes.DOCUMENTS_SUCCESS, actionTypes.DOCUMENTS_FAILURE)]: () => false,
    [actionTypes.DOCUMENTS_REQUEST]: () => true,
  },
  false,
);

export const error = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.DOCUMENTS_REQUEST,
      actionTypes.DOCUMENTS_SUCCESS,
    )]: () => ({}),
    [combineActions(actionTypes.DOCUMENTS_FAILURE)]: (state, { payload }) => payload.error,
  },
  {},
);

export default combineReducers({
  documents,
  isLoading,
  error,
});
